export interface DocumentDetailsEntity {
  success: boolean;
  title: string;
  article_number: number | null;
  type: string;
  assets?: {
    name: string;
    type: string;
    url: string;
    language: string;
  }[];
  languages?: string[];
  validFrom: Date | null;
  validTill: Date | null;
  is_bookmarked: boolean;
  ident?: string;
}

// Returned instead of DocumentDetailsEntity when the document moved to another category (e.g. after a 301)
export interface DocumentDetailsRedirectResponse {
  success: false;
  document_id: number;
  category_ids: number[];
}

// Type guard for the 301 case: detects the {success:false, category_ids} shape
export function isDocumentDetailsRedirectResponse(
  response: DocumentDetailsEntity | DocumentDetailsRedirectResponse,
): response is DocumentDetailsRedirectResponse {
  return response?.success === false && Array.isArray((response as DocumentDetailsRedirectResponse).category_ids);
}
